import { URLS } from "@/base/utils/urls";
import { FieldSet, useFieldSet } from "@/components/utils/useFieldSet";
import { LinkButton } from "@/flokit/core/button/link-button";
import { useRouter } from "next/router";
import { sendAgencyContactSigninMagicLink } from "../../../../../modules/api-docs";
import { ModalService } from "../../../../services/modal.service";
import {
  BaseVerifyEmailSignInModal,
  baseEmailSchema,
} from "./base-signin-modal";

const AgencyContactSignInModal = () => {
  const emailFieldSet = useFieldSet({ email: "" }, [], baseEmailSchema);
  const router = useRouter();
  const org = router.query.org as string;

  return (
    <BaseVerifyEmailSignInModal
      emailFieldSet={emailFieldSet as FieldSet<{ email: string }>}
      org={org}
      title="Agency Sign in"
      center
      subtitle={
        <LinkButton
          href={URLS.selfApplyJobsList(org, true)}
          onClick={() => {
            ModalService.closeModal();
          }}
          color="custom"
          UNSAFE_className="!px-0 !mx-0 !w-fit !inline-flex !text-navy !font-semibold"
        >
          Are you a candidate? Click here
        </LinkButton>
      }
      emailFieldLabel="Agency Email"
      sentMessage="If you are an authorized recruiting agency, your email will arrive in a few minutes. Check spam if you don't see it in your inbox."
      onEmailChange={(val) => {
        emailFieldSet.setValue("email", val);
      }}
      onSubmitSignInEmailRequest={async () => {
        return sendAgencyContactSigninMagicLink({
          email: emailFieldSet.values.email,
          orgFriendlyName: org,
          redirectUrl: window.location.pathname,
        });
      }}
    />
  );
};

export const openAgencyEmailSignInModal = () => {
  ModalService.openModal(
    () => {
      return <AgencyContactSignInModal />;
    },
    {
      width: 520,
      mobileFriendly: true,
      preventAutoFocus: true,
    },
  );
};
